<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { initFileUploadValue } from ".";

  export let klass: string = "";
  export let value = initFileUploadValue();
  let fileInput;

  const dispatch = createEventDispatcher();

  function input(e) {
    dispatch("input", {
      value: e,
    });
  }

  const onFileSelected = (e) => {
    if (e.target.files.length === 0) {
      return;
    }

    let file = e.target.files[0];
    let reader = new FileReader();
    value.filename = file.name;
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      value.base64 = e.target.result as string;
      input(value);
    };
  };

  $: label = value.base64 ? value.filename : "ファイルを選択";
</script>

<div class={klass}>
  <div class="placeholder" on:click={fileInput.click()}>{label}</div>
  <input
    type="file"
    style="display: none;"
    accept="text/csv"
    on:change={(e) => onFileSelected(e)}
    bind:this={fileInput}
  />
</div>

<style lang="postcss">
  .placeholder {
    height: 200px;

    @apply cursor-pointer bg-gray-100 rounded-xl;
    @apply flex justify-center items-center;
    @apply border-2 border-dashed;
  }
</style>
